document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('featured-product-form')) {
    customElements.define(
      'featured-product-form',
      class FeaturedProductForm extends customElements.get('product-form') {
        formatMoney(cents) {
          return new Intl.NumberFormat(undefined, {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(cents / 100);
        }
        constructor() {
          super();
          this.variantPicker = this.querySelectorAll(`[data-featured-product-variant-picker]`);
          this.variantPicker.forEach((picker) => {
            picker.addEventListener('change', this.handleVariantChange.bind(this));
          });
          this.sectionElement = this.querySelector(`product-form`);

          const checkedVariant = this.querySelector('[data-featured-product-variant-picker]:checked');

          if (checkedVariant) {
            const variant = JSON.parse(checkedVariant.dataset.variant);

            window.theme = window.theme || {};
            window.theme.currentVariant = variant;

            // const button = this.querySelector('[name="add"]');
            // const priceEl = button?.querySelector('.add-to-cart-price');
            // if (priceEl) {
            //   priceEl.textContent = `- ${this.formatMoney(variant.price)}`;
            // }
          }
        }
        handleVariantChange(evt) {
          this.updateFormInput(this.form, evt.target);
          this.handleOneTimePurchase(evt);
          const variant = JSON.parse(evt.target.dataset.variant);

          window.theme = window.theme || {};
          window.theme.currentVariant = variant;

          const submitButton = this.querySelector('[name="add"]');
          const oneTimeButton = this.querySelector('.product-form__one-time-button');
          const priceEls = [
            submitButton?.querySelector('.add-to-cart-price'),
            oneTimeButton?.querySelector('.add-to-cart-price'),
          ].filter(Boolean);

          priceEls.forEach((el) => {
            el.textContent = `- ${this.formatMoney(variant.price)}`;
          });
        }
        updateFormInput(form, target) {
          form.querySelector(`[name="id"]`).value = target.value;
          form.querySelector(`[name="selling_plan"]`).value = target.dataset.sellingPlanId;
        }
        handleOneTimePurchase(evt) {
          if (evt.target.dataset.firmhousePopup) {
            this.sectionElement.classList.add('hide-normal-buy-button');
          } else {
            this.sectionElement.classList.remove('hide-normal-buy-button');
          }
        }
        onSubmitHandler(evt) {
          super.onSubmitHandler(evt);
        }
        handleErrorMessage(errorMessage = false) {
          super.handleErrorMessage(errorMessage);
        }
      },
    );
  }
});
